const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');
import { axiosInstance as axios } from '../../utils/axios';

import { PAGINATION_PAGE_SIZE } from '../../config-global';

export const getNews = createAsyncThunk('get/news', async (params) => {
  try {
    const response = await axios.get('api/noticias', {
      params: {
        populate: '*',
        'sort[0]': 'publishedAt:desc',
        'pagination[pageSize]': Number(PAGINATION_PAGE_SIZE ?? 15),
        'pagination[page]': Number(params?.page ?? 1),
      },
    });
    return response.data;
  } catch (error) {}
});

export const getNewsById = createAsyncThunk('get/news/id', async (id) => {
  try {
    const response = await axios.get(`api/noticias/${id}`, {
      params: {
        populate: '*',
      },
    });
    return response.data;
  } catch (error) {}
});

const initialState = {
  isLoading: false,
  data: [],
  meta: {},
  news: {},
};

const newsSlice = createSlice({
  name: 'news',
  initialState,
  extraReducers: {
    [getNews.pending]: (state) => {
      state.isLoading = true;
    },
    [getNews.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.data = action.payload?.data;
      state.meta = action.payload?.meta;
    },
    [getNews.rejected]: (state) => {
      state.isLoading = false;
    },

    //News By Id

    [getNewsById.pending]: (state) => {
      state.isLoading = true;
    },
    [getNewsById.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.news = action.payload?.data;
    },
    [getNewsById.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const newsReducer = newsSlice.reducer;

export const isNewsLoading = (state) => state.news.isLoading;
export const newsMeta = (state) => state.news.meta;
export const allNews = (state) => {
  let data = state.news.data;
  let news = [];

  if (data) {
    data.forEach((element) => {
      if (element.attributes?.imagem_destaque?.data?.attributes?.url) {
        news.push({
          id: element.id,
          title: element?.attributes?.titulo,
          publishedAt: element?.attributes?.publishedAt,
          imageUrl:
            /*APP_HOST_API_KEY +*/ element.attributes?.imagem_destaque?.data?.attributes?.url,
        });
      }
    });
  }

  return news;
};

export const newsData = (state) => {
  let data = state.news.news;

  if (data) {
    let images = [];
    if (data.attributes?.imagens?.data) {
      // Get only 3 images
      let i = 0;
      data.attributes?.imagens?.data.forEach((image) => {
        if (i == 3) {
          return;
        }
        images.push(/*APP_HOST_API_KEY + */ image.attributes.url);
        i += 1;
      });
    }
    return {
      id: data.id,
      title: data.attributes?.titulo,
      description: data.attributes?.texto,
      images: images,
    };
  }
  return null;
};
